module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "An Eye for Glory: The Civil War Chronicles of a Citizen Soldier"
    }
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("August, 1882")])])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "nonindent"
  }, [_vm._v("To My Dear Children – Sarah, Edward, and James,")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("You may be wondering why, at this time in my earthly pilgrimage, some twenty years since my enlistment in the Union Army, I should pen such a manuscript as this. You have asked me countless times to tell of my experiences during the Great War of Rebellion. Until this writing I have always answered with but small morsels of the story, and I never satisfied your appetite with a full and true accounting of what occurred, perhaps because I was not inclined to recount the many dark and painful memories. So many good friends, brothers in arms and in the faith, were lost, and I still mourn each one. That I survived the war, and returned to the bosom of my family, can only be attributed to the abundant mercy and grace of our Almighty Father, for I deserved no such mercy, no such grace.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The recent death of your mother, my dearest Jessie Anne, has once again caused me to consider the brevity of my own earthly existence. Although I am not yet an old man, at least so far as I think of it, I do not know when I shall be called to put off this earthly tent and receive my eternal inheritance; then who shall write of these things? You are older ‘now – Sarah has married, Edward shall shortly marry, and James has but one year of school remaining – so it seems prudent to set down on paper these remembrances of the war before the memories fade forever.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("A soldier’s life is filled with long stretches of interminable boredom in camp or on the march, broken only by short periods of confusion and terror in battle. Throughout the war, I kept a series of journals in which I recorded my experiences. As I filled each ")]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("journal with notes and musings, I posted it home and your mother sent me a new one. The writing of these journals and letters helped me immeasurably, during both pleasant days and not, to pass the time in a more fruitful manner. She also preserved every letter I ever wrote to her and I kept most of her letters to me. These have served well to refresh my memory. I have included several of those letters, either in part or in their entirety, so that you might better understand how we were sustained throughout those long years. However, the more personal contents of these correspondences shall forever remain between your mother and me.")])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("No man could wish to have three finer children. When I think that not only do you not harbor any ill will toward me, but that your love for me has remained steadfast and undiminished through all these years, I can only marvel at God’s goodness. Your mother was certainly the primary instrument of this goodness, since for such a long time, I had little to do with your rearing and did little deserving of your affection.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And so I write to you, Sarah, Edward, and James, and to your children after you, not as excuse or explanation of my actions, but rather as confession, for surely I was granted a most profound and gracious forgiveness, by yourselves, by your dear mother, and by God, for which I am sincerely thankful.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("May these words also serve as a memorial, not of me and of what I did, but of the fallen, those noble men who fought “with firmness in the right, as God gave us to see the right.”")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("With sincerest affection"), _c('br'), _vm._v(" I remain your loving father,")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "role": "presentation",
      "src": "images/16-1.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page16"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6481bf54","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780310412625_epub_fm2_r1.vue
// module id = 78
// module chunks = 0